import { createAsyncThunk } from "@reduxjs/toolkit";

import { ThunkConfig } from "@/app/providers/StoreProvider";
import { handleError } from "@/shared/lib/helpers/utils";
import { ApiError } from "@/shared/types";

import { captureException } from "@sentry/react";

interface CreateSubscriptionProps {
  stripePriceId: string;
}

export const createSubscription = createAsyncThunk<void, CreateSubscriptionProps, ThunkConfig<ApiError>>(
  "subscription/createSubscription",
  async ({ stripePriceId }, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
      await extra.api.post("/api/subscription/create_subscription", {
        stripe_price_id: stripePriceId,
      });
    } catch (err) {
      captureException(err);

      return rejectWithValue(handleError(err));
    }
  }
);
